export default {"src":"/_next/static/media/backyard.3ad8d19d.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};